export const ResearchProjectTypes = {
    GRADUATE_WORK: "Дипломна робота",
    COURSEWORK: "Курсова робота",
    EDUCATIONAL_MATERIALS: "Навчальні матеріали",
    UNKNOWN_WORK_TYPE: "Тип роботи відсутній",
};